import { VStack } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const DatePickerContainer: FC<PropsWithChildren> = ({ children }) => (
  <VStack w="100%" as="section" spacing="2">
    {children}
  </VStack>
);
